import React from "react";
import { gql, useQuery } from "@apollo/client";
import { getUserLoginData as User } from "types/gql-types";
import ResetPasswordFormModal from "./reset-password-form";

type Props = {
  userId?: string | null;
  currentInterestName: string;
  isOpen: boolean;
  onRequestClose: () => void;
  onCancel: () => void;
}

const USER_QUERY = gql`
  query getUserLoginData($id: ID!) {
    user(id: $id) {
      email
      phone
    }
  }
`;

const ResetPasswordFormContainer: React.FC<Props> = ({
  userId,
  currentInterestName,
  isOpen,
  onRequestClose,
  onCancel,
}) => {
  const shouldSkip = !isOpen || !userId;

  const { data } = useQuery<User>(USER_QUERY, {
    // eslint-disable-next-line no-undefined
    variables: userId ? { id: userId } : undefined,
    skip: shouldSkip,
  });

  const user = data?.user;

  if (!isOpen) return null;
  if (!user) return null;

  return (
    <ResetPasswordFormModal
      currentInterestName={currentInterestName}
      isOpen={isOpen}
      user={user}
      onRequestClose={onRequestClose}
      onCancel={onCancel}
    />
  );
};

export default ResetPasswordFormContainer;


